<template>
  <div id="app">
    <router-view />
    <bottom-nav v-if="showNav" />
  </div>
</template>

<script>
import BottomNav from './components/BottomNav.vue'

export default {
  name: 'App',
  components: { BottomNav },
  computed: {
    showNav() {
      const hide = ['/', '/login', '/register']
      return !hide.includes(this.$route.path)
    }
  }
}
</script>
